<template>
  <zj-layout-container>
    <zj-layout-header>
      <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="出现时间">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 60rem"
            unlink-panels
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div style="width:100%;height:auto">
          <div v-for="avatar in avatars" :key="avatar" class="avatar">
            <div @dblclick="ondbClickAv(avatar)">
              <el-avatar shape="square" :size="120" fit="fill" :src="avatar.url"></el-avatar>
              <div style="padding: 0.5rem;">{{avatar.cameraName}}</div>
              <div style="padding: 0.5rem;">{{avatar.time}}</div>
            </div>
          </div>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
    <div>
      <el-dialog :visible.sync="dialogVisible">
        <div style="padding:1rem">
          <el-form :model="selectedavatar">
            <el-image shape="square" fit="fill" :src="selectedavatar.url" style="width:100%"></el-image>
            <el-form-item label style="padding-top:3rem" class="center">
              <el-button @click="onControlAvatar(selectedavatar)">布 控</el-button>
              <el-button @click="onSearchAvatar(selectedavatar)" style="margin-left:5rem">搜 索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </zj-layout-container>
</template>
<script>
export default {
  name: "FaceList",
  controller: "UI",
  action: "FaceList",
  data() {
    return {
      date: [new Date(), new Date()],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      IndexCode: "",
      DeviceName: "",
      avatars: [],
      dialogVisible: false,
      selectedavatar: Object,
    };
  },
  methods: {
    refreshImage(data) {
      this.IndexCode = data.IndexCode;
      this.DeviceName = data.label;
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    search() {
      this.avatars = [
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
        {
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          time: new Date().format("yyyy-MM-dd hh:mm:ss"),
          cameraName: this.DeviceName,
        },
      ];
    },
    ondbClickAv(avatar) {
      this.dialogVisible = true;
      this.selectedavatar = avatar;
    },
    //搜索
    onSearchAvatar(avatar) {
      this.$router.push({
        path: "/plugin/Face/UI/FaceAuatarList",
        query: { avatarobj: avatar, date: new Date() },
      });
    },
    onCancel(){
      this.date=[new Date(), new Date()];
    },
    //布控
    onControlAvatar(avatar) {
       this.$router.push({
        path: "/plugin/Face/UI/FaceAddControl",
        query: { url: avatar.url, date: new Date() },
      });
    },
  },
};
</script>
<style>
.avatar {
  display: block;
  float: left;
  padding: 1.5rem;
}
</style>